<template>
  <div>
    <CRow>
      <CCol sm="12">
        <CurrenciesTable
          :items="currencies"
          hover
          striped
          border
          small
          fixed
          caption="Monedas"
          @refresh="refreshItems"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import CurrenciesTable from '../../components/configuration/currencies/CurrenciesTable.vue'
import ws from '../../services/currencies';
import store from '../../store'

export default {
  name: 'Currencies',
  components: { CurrenciesTable },
  data: function () {
		return {
            currencies: []
        }
  },
  mounted: async function() {
    this.loading();
    let response = await ws.get(); 

    if(response.type == "success"){
      this.currencies = response.data;
    }
    this.loaded();
  },
  methods: {
    async refreshItems (items){
      this.loading();
      let response = await ws.get();

      if(response.type == "success"){
        this.currencies = response.data;
      }

      this.loaded();
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
